import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PropertyProfileContainer from '../../Property/Property/PropertyProfileContainer/PropertyProfileContainer';

export default function PropertyProfilePage({
	get_property_endpoint,
	get_property_ownership_by_property_endpoint
}) {
	return (
		<div>
			<div className="-mt-8 md:-mt-12 mb-8 md:mb-12 md:text-xl">
				<Link
					to="/dashboard"
					className="hover:underline mr-2 md:mr-3"
				>
					Dashboard
				</Link>
				<i
					className="text-gray-400 fa fa-chevron-right text-xs md:text-base mr-2 md:mr-3"
					aria-hidden="true"
				/>
			</div>
			<PropertyProfileContainer
				get_property_endpoint={get_property_endpoint}
				get_property_ownership_by_property_endpoint={
					get_property_ownership_by_property_endpoint
				}
			/>
		</div>
	);
}

PropertyProfilePage.propTypes = {
	get_property_endpoint: PropTypes.string.isRequired,
	get_property_ownership_by_property_endpoint: PropTypes.string.isRequired
};
